import React, { useState, useMemo } from 'react'
import { Modal, Input, Button } from 'antd'
import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { FEELINGS } from '../../constants/newsFeedConstants'

const FeelingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  max-height: 380px;
  overflow-y: auto;
  padding: 4px;
  margin-top: 12px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

const FeelingItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
  background: ${props => (props.selected ? '#e0f2fe' : '#ffffff')};
  border: 1px solid ${props => (props.selected ? '#7dd3fc' : '#f1f5f9')};
  transition: all 0.15s ease;

  &:hover {
    background: ${props => (props.selected ? '#e0f2fe' : '#f8fafc')};
    border-color: #cbd5e1;
    transform: translateY(-1px);
  }

  .emoji {
    font-size: 26px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #f1f5f9;
    flex-shrink: 0;
  }

  .info {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .label {
      font-weight: 600;
      font-size: 14px;
      color: #0f172a;
    }

    .desc {
      font-size: 12px;
      color: #64748b;
    }
  }
`

const FeelingSelectModal = ({
  visible,
  onClose,
  onSelectFeeling,
  selectedFeeling,
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  const removeAccents = str =>
    str
      ? str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/đ/g, 'd')
          .replace(/Đ/g, 'D')
      : ''

  const filteredFeelings = useMemo(() => {
    if (!searchTerm.trim()) return FEELINGS
    const query = removeAccents(searchTerm.trim().toLowerCase())
    return FEELINGS.filter(f => {
      const matchLabel = removeAccents(f.label.toLowerCase()).includes(query)
      const matchText = removeAccents(f.text.toLowerCase()).includes(query)
      return matchLabel || matchText
    })
  }, [searchTerm])

  return (
    <Modal
      title={
        <div style={{ textAlign: 'center', fontSize: 17, fontWeight: 700 }}>
          Bạn đang cảm thấy thế nào?
        </div>
      }
      visible={visible}
      onCancel={() => {
        setSearchTerm('')
        onClose()
      }}
      footer={
        selectedFeeling ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <span style={{ fontSize: 13, color: '#64748b' }}>
              Đang chọn: {selectedFeeling.emoji} {selectedFeeling.text}
            </span>
            <Button
              type="text"
              danger
              icon={<CloseCircleOutlined />}
              onClick={() => {
                onSelectFeeling(null)
                setSearchTerm('')
                onClose()
              }}>
              Gỡ cảm xúc
            </Button>
          </div>
        ) : null
      }
      width={500}
      centered
      destroyOnClose
      bodyStyle={{ padding: '16px 20px' }}>
      <Input
        prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
        placeholder="Tìm kiếm cảm xúc (ví dụ: tự hào, vui vẻ, hạnh phúc...)"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        allowClear
        style={{
          borderRadius: 20,
          padding: '6px 14px',
          background: '#f8fafc',
        }}
      />

      <FeelingsGrid>
        {filteredFeelings.map(feeling => {
          const isSelected = selectedFeeling?.key === feeling.key
          return (
            <FeelingItem
              key={feeling.key}
              selected={isSelected}
              onClick={() => {
                onSelectFeeling(feeling)
                setSearchTerm('')
                onClose()
              }}>
              <div className="emoji">{feeling.emoji}</div>
              <div className="info">
                <span className="label">{feeling.label}</span>
                <span className="desc">{feeling.text}</span>
              </div>
            </FeelingItem>
          )
        })}
      </FeelingsGrid>

      {filteredFeelings.length === 0 && (
        <div
          style={{
            textAlign: 'center',
            padding: '30px 0',
            color: '#94a3b8',
            fontSize: 14,
          }}>
          Không tìm thấy cảm xúc phù hợp
        </div>
      )}
    </Modal>
  )
}

export default FeelingSelectModal
